import { ArrowDown } from 'lucide-react';
import { SERVICES_HERO } from '@/data/services';
import { Reveal } from '../Reveal';
import { scrollToId } from '@/lib/scroll';

export const ServicesHero = () => (
  <section aria-labelledby="services-hero-heading" data-testid="services-hero" className="bg-white py-16 sm:py-24">
    <div className="mx-auto grid max-w-7xl items-center gap-12 px-4 sm:px-6 lg:grid-cols-2 lg:gap-16 lg:px-8">
      <Reveal>
        <p className="flex items-center gap-3">
          <span className="font-mono text-xs font-medium tracking-widest text-gold-700">01</span>
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-gold-700">
            {SERVICES_HERO.eyebrow}
          </span>
        </p>
        <h1
          id="services-hero-heading"
          data-testid="services-hero-heading"
          className="mt-4 text-balance text-4xl font-extrabold tracking-tight text-navy-900 sm:text-5xl"
        >
          {SERVICES_HERO.heading}
        </h1>
        <p className="mt-5 max-w-xl text-base leading-relaxed text-slate-600 sm:text-lg">
          {SERVICES_HERO.copy}
        </p>
        <p className="mt-3 max-w-xl border-l-2 border-gold-500 pl-4 text-sm font-medium italic leading-relaxed text-navy-800">
          {SERVICES_HERO.supportingLine}
        </p>
        <div className="mt-8 flex flex-col gap-3 sm:flex-row">
          <button
            type="button"
            onClick={() => scrollToId(SERVICES_HERO.primaryTarget)}
            data-testid="services-explore-btn"
            className="group inline-flex items-center justify-center gap-2 rounded-md bg-navy-900 px-6 py-3.5 text-sm font-bold text-white transition-colors hover:bg-navy-700"
          >
            {SERVICES_HERO.primaryLabel}
            <ArrowDown className="h-4 w-4 transition-transform duration-200 group-hover:translate-y-0.5" aria-hidden="true" />
          </button>
          <button
            type="button"
            onClick={() => scrollToId(SERVICES_HERO.secondaryTarget)}
            data-testid="services-tell-us-btn"
            className="group inline-flex items-center justify-center gap-2 rounded-md border-2 border-navy-900 px-6 py-3 text-sm font-bold text-navy-900 transition-colors hover:bg-navy-900 hover:text-white"
          >
            {SERVICES_HERO.secondaryLabel}
            <ArrowDown className="h-4 w-4 transition-transform duration-200 group-hover:translate-y-0.5" aria-hidden="true" />
          </button>
        </div>
      </Reveal>

      <Reveal delay={0.12}>
        <img
          src={SERVICES_HERO.image?.src}
          alt={SERVICES_HERO.image.alt}
          width={SERVICES_HERO.image.width}
          height={SERVICES_HERO.image.height}
          data-testid="services-hero-image"
          className="aspect-[4/3] w-full rounded-2xl object-cover shadow-lift"
        />
      </Reveal>
    </div>
  </section>
);
